
import React from 'react';
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Badge } from "@/components/ui/badge";

const Pricing = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        <section className="section-padding">
          <div className="container mx-auto px-4 md:px-6">
            <div className="text-center max-w-3xl mx-auto mb-16">
              <Badge className="mb-4 bg-carewarm-100 text-carewarm-600 hover:bg-carewarm-200">Pricing</Badge>
              <h1 className="text-4xl md:text-5xl font-bold mb-6 text-careblue-800">Simple, Fair Pricing</h1>
              <p className="text-xl text-muted-foreground">
                Affordable tools for caregivers who are already managing significant expenses.
              </p>
            </div>
            
            <div className="max-w-4xl mx-auto">
              <div className="bg-white rounded-xl p-8 shadow-soft border border-careblue-100 text-center">
                <h2 className="text-3xl font-bold mb-4 text-careblue-800">Pricing Details Coming Soon</h2>
                <p className="text-lg text-muted-foreground mb-8">
                  We're finalizing our pricing structure to ensure it's accessible for all caregivers. 
                  Our goal is to provide maximum value while keeping costs low.
                </p>
                
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                  <div className="p-6 bg-careblue-50 rounded-lg">
                    <h3 className="font-bold text-careblue-800 mb-2">Accessible</h3>
                    <p className="text-sm text-muted-foreground">Priced with caregivers' budgets in mind</p>
                  </div>
                  <div className="p-6 bg-careblue-50 rounded-lg">
                    <h3 className="font-bold text-careblue-800 mb-2">Transparent</h3>
                    <p className="text-sm text-muted-foreground">No hidden fees or surprise charges</p>
                  </div>
                  <div className="p-6 bg-careblue-50 rounded-lg">
                    <h3 className="font-bold text-careblue-800 mb-2">Value-First</h3>
                    <p className="text-sm text-muted-foreground">Tools that help you save more than they cost</p>
                  </div>
                </div>
                
                <button className="bg-careblue-500 hover:bg-careblue-600 text-white py-3 px-6 rounded-lg font-medium transition-colors">
                  Join Waitlist for Early Access Pricing
                </button>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Pricing;
